import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=c56546f0&scoped=true&"
import script from "./CardItem.vue?vue&type=script&lang=ts&"
export * from "./CardItem.vue?vue&type=script&lang=ts&"
import style0 from "./CardItem.vue?vue&type=style&index=0&id=c56546f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56546f0",
  null
  
)

export default component.exports